import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../services/api.service';


interface DecodedToken {
  exp: number;
  iat: number;
  sub: string;  // typically the user identifier
  // Add other expected fields here
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private apiService: ApiService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenUser = localStorage.getItem('tokenUser');
    const tokenTenant = localStorage.getItem('tokenTenant');
    const tokenLocal = localStorage.getItem('token');
    const platform = localStorage.getItem('src_app');

    if (platform === 'pharmalien') {
      // Pharmalien platform: only needs tokenUser and tokenLocal
      if (tokenUser && tokenLocal) {
        if (!this.apiService.isLoggedIn()) {
          this.logout();
          return throwError(() => new Error('Token has expired'));
        }

        const cloned = req.clone({
          headers: req.headers
            .set('Authorization', `Bearer ${tokenLocal}`)
            .set('AuthorizationUser', `BearerUser ${JSON.parse(tokenUser).accessToken}`)
        });
        return next.handle(cloned).pipe(
          catchError((error) => {
            if (error.status === 401 || error.status === 403) {
              this.logout();
            }
            return throwError(() => error);
          })
        );
      }
    } else if (platform === 'windoc_direct') {
      // WinDoc Direct platform: only needs tokenLocal with AuthorizationLocal header
      if (tokenLocal) {
        if (!this.apiService.isLoggedIn()) {
          this.logout();
          return throwError(() => new Error('Token has expired'));
        }

        const cloned = req.clone({
          headers: req.headers
            .set('AuthorizationLocal', `Bearer ${tokenLocal}`)
        });
        return next.handle(cloned).pipe(
          catchError((error) => {
            if (error.status === 401 || error.status === 403) {
              this.logout();
            }
            return throwError(() => error);
          })
        );
      }
    } else if (platform === 'winpluspharma') {
      // WinPlus platform: needs all three tokens
      if (tokenUser && tokenTenant && tokenLocal) {
        if (!this.apiService.isLoggedIn()) {
          this.logout();
          return throwError(() => new Error('Token has expired'));
        }

        const cloned = req.clone({
          headers: req.headers
            .set('Authorization', `Bearer ${tokenLocal}`)
            .set('AuthorizationTenant', `BearerTenant ${JSON.parse(tokenTenant).accessToken}`)
            .set('AuthorizationUser', `BearerUser ${JSON.parse(tokenUser).accessToken}`)
        });
        return next.handle(cloned).pipe(
          catchError((error) => {
            if (error.status === 401 || error.status === 403) {
              this.logout();
            }
            return throwError(() => error);
          })
        );
      }
    }

    return next.handle(req);
  }

  isTokenExpired(token: string): boolean {
    const decodedToken: any = jwtDecode(token);
    const expirationDate = new Date(decodedToken.exp * 1000);
    return expirationDate < new Date();
  }



  logout() {
    localStorage.removeItem('tokenUser');
    localStorage.removeItem('tokenTenant');
    localStorage.removeItem('token');
    localStorage.removeItem('credentials');
    localStorage.removeItem('ocrMode');
    // Keep src_app to remember platform choice
    // Redirect the user to the login page or show a logout message
  }
}